<template>
  <div vview:await id=__mymenu__ class="__mymenu__" >
    
    <!-- <ul>
      <li z-for='#Contextmenus' s:font-size=':13px' s:display=':inline-block'>[[ @value ]]</li>
    </ul> -->
    <span v-if=' xxxyyy === void 0 ' v-event.*showMenus='`return boolean=true, a && ( string = a )`'></span>

    <el-autocomplete  
      ref='input'
      v-show='notkeepalive === false ? true : boolean ? $trigger("focus") : false'
      v-event.focus='`window.sleep(50,v=>C.getInput().focus())`'
      v-model="string" clearable
      :fetch-suggestions="queryMenus"
      :popper-append-to-body=false
      :debounce='0'
      placeholder="请输入或选择你想要跳转的菜单关键字 (小提示: 双击Ctrl | Ctrl+空格 | 双击空格 切换显示隐藏)"
      style='width:100%;font-size:16px;box-shadow: rgba(128, 128, 128, 0.62) 0px 7px 12px 8px;transition:all 250ms linear;position:relative;'
      v-s.z-index='notkeepalive ? 777777 : 777'
      :style='inputstyle||""'
      
      :popper-class=' menuclass || "fullscreenSelect" '
      @keydown.native='$event.key === "Escape" && ( boolean = false )'
      @blur='notkeepalive && window.sleep(100.123456,hide)'
      @keydown.enter.native="Try(string)"
      select="selectMenu"
      >
      <template slot-scope="{ item }" ><!--  -->
        <div v-if='item.parent.length>0 && item.show' class="flex" style="cursor:auto;" @click.stop.prevent='window.sleep.clear(100.123456)'>
          <div >
            <span class="cPointer" @click.stop.capture='selectMenu(item)' id="__menu_item__" :title="'跳到这个菜单组 ' + ( item.url || '' ) ">
              <span :class="item.icon" style="color:var(--Themecolor);margin-right:10px;" class="font16 blackFont" ></span>
              <span class="inBlock" style="min-width:140px;"> {{ item.name }}</span>
            </span>
          
            <span class="el-icon-arrow-right blackFont" style="margin-right:15px;"></span>

          </div>
          
          <div class="fCenterY" style="flex-wrap: wrap;">
            <div v-for=' item in item.submenus ' :key='item.index' style="margin:0 10px;" class="inBlock cPointer" 
                @click.stop.capture='selectMenu(item)' id="__menu_item__" :title=" '跳转到这个子菜单: ' + item.path ">
              <span class="font16 blackFont" :class="item.icon" style="color:var(--Themecolor);margin-right:10px;"  ></span>
              <span class="inBlock" style="min-width:120px;"> {{ item.name }}</span>
            </div>
          </div>

        </div>
        <!-- <span class="addr">{{ item.address }}</span> -->
      </template>
    </el-autocomplete>
    
    <!-- <div class="myMask" id='hahaha' style="z-index:10;top:70px;background:transparent;"></div> -->

    <!-- <button v-event:click='`test(...arguments)`'>44444444444444444444444</button> -->
    
    <!-- <input type="text" z:value='#queryFirstClass_data && #queryFirstClass_data.pageSize'> -->
    <!-- <input type="text" x:value='queryFirstClass_data && queryFirstClass_data.pageSize'> -->
    <!-- <span>[[ #queryFirstClass_data ]]</span> -->
  
    <!-- <el-input v-model='string' zmodel='queryFirstClass_data'></el-input> -->
    <!-- <image-video show='boolean' :urls='[]'></image-video> -->

  </div>
</template>

<script >

import match from '@/utils/PinyinMatch.js';

const PinyinMatch = match.match; // PinyinMatch( value, keyword ) 中文模糊拼音匹配

// const W = window, $Menus = W.$Menus, Chinamenus = $Menus.Chinamenus;
// const Menus = Return( Chinamenus, (menuobj,value,key)=>menuobj.push(key), [ ] );

let $this;
/* 双击Ctrl键 或 ctrl+空格 或 双击空格 => 快速打开指定的菜单搜索框 */
const queryMenus = ()=>{
  (async function queryMenus(event){
    //win = await keyUp('MetaLeft');
    // console.warn('等待..');
    if( event ) {
      (function ctrl2(){
        keyUp('ControlLeft').then(async event=>{
          ( event = await keyDown('ControlLeft',-300) ) 
          && ( /*console.error(event), */ event = await keyUp('ControlLeft',-200) )
          && ( $this.boolean = !$this.boolean );
          ctrl2();
        });
      })();
    };
    
    event = await keyUp('space');
    // console.log(event,$this);
    if( event.ctrlKey ) {
      // console.error(space.stopPropagation(),'请求搜索..');
      $this.boolean = !$this.boolean;
    }else if(!document.activeElement.nodeName.match(/input|textarea/i)){
      ( event = await keyDown('space',-200) ) 
      && ( event = await keyUp('space',-200) )
      && ( $this.boolean = !$this.boolean );
    };

    queryMenus();

  })(true);
};

queryMenus();
// console.error(111111111);

export default {

  props: [ 'keepalive', 'inputstyle', 'menuclass', 'xxxyyy' ],

  data() {
    return {
      Contextmenus: [

      ],
    };
  },
  
  watch: {
    
  },

  computed: {
    notkeepalive( ) {
      const keepalive = this.keepalive;
      return keepalive === void 0 || keepalive !== "" && !keepalive ? ( $this = this, true ) : false;
    }
  },

  methods: {
    test(){
      this.$trigger('queryFirstClass');
    },

    hide() {
      this.boolean = this.string = "";
    },

    Try(string) {
      try {
        window.eval(string);
      } catch(e) {
        // statements
        // console.log(e);
      };
      return;
    },

    queryMenus(keyword,render) {
      /*if( keyword.endsWith('#') ) {
        eval( keyword.slice(0,-1) );
        return render([]);
      };*/
      keyword = keyword.toLowerCase();
      var menus = Return( $Menus.Chinamenus, (menuobj,value,key)=>{
        value.show !== false && menuobj.push(value)
      }, [ ] ), results = [], tmp, tmp2; //JS = JSON.parse,
      // console.error(menus);
      if( keyword === '' ) return render(menus);
      for( tmp of menus ) {
        if( !PinyinMatch( (tmp.name||'').toLowerCase(), keyword ) && !(tmp.url||'').toLowerCase().includes( keyword ) ) continue;
        // console.error( tmp );
        while( true ) {
          // console.warn( tmp, 11111 );
          if( tmp.parent.length ) { 
            !results.includes( tmp ) && ( results[ results.length++ ] = tmp ); 
            break;
          };
          tmp = tmp.parent;
        };
      };
      // console.warn( results );
      render(results);
    },

    selectMenu(menu){
      // console.error(Chinamenus[ value ].url);
      // value = Chinamenus[ value ];
      sleep.clear(100.123456);
      // this.$lastsel = true;
      menu.url && !menu.submenus
      ? this.$push( menu.url )
      : ( $Menus.actived.opened = [ menu.index ], $Menus.actived.collapse = false );
      this.hide();
    },

  },

  created() {
    /*this.Contextmenus = Return( Chinamenus, (menuobj,value,key)=>{
      value.show !== false && menuobj.push(value)
    }, [ ] );*/

    // console.warn('菜单mymenu::', W.a = this);
    // console.error( this.$trigger('querySecondClass',{xxx: 888}) );

    // this.$trigger('v-event:click', 'clickParam-a')
    //     .trigger('localmethod'  , {params:'...'}) => ( :EltableData = this.localmethod_data{}.data[...?]  )
    //     .trigger('globalmethod' , {params:'...'}) => ( :EltreeData  = this.globalmethod_data{}.data[...?] )
    //     .sync()
    //     .nextick()                                => 等待 dom 渲染完毕之后
    //     .sleep(50)                                => 睡眠延迟50ms之后
    //     .$trigger()                               => 同时 开启另一个$trigger实例线程事件队列
    //     .form('previewForm','show')               => 第二个$trigger显示查看表单
    //     .nextTick()
    //     .localmethod({params:'...'})              => 链式调用本地方法( 仅支持本地方法, 全局方法暂不支持直接点点 )
    //     .globalmethod({params:'...'})             => 链式调用全局方法( 仅支持本地方法, 全局方法暂不支持直接点点 )
  },

  // activated( ) {
  //   console.error( this, '首页激活了....' );
  // },

  /*deactivated( ) {
    console.error( this, '首页取消激活了....' );
  },*/

  /*destroyed() {
    console.error('菜单破坏了');
  },*/

  mounted: async function( ){
    if( this.notkeepalive === false ) {
      await sleep(5);
      // this.$trigger("focus");
      const input = this.$refs.input.getInput(); input.focus();
      await this.$nextTick();
      delete this.$refs.input.activated;
      input.blur();
      // console.error(this.$refs.input);
    };
  }

};

</script>

<style scoped>
  
  #__mymenu__ {
    position: fixed;
    width: 101%;
    left: -3px;
    top: 0;
    z-index: 777777;
  }

  .__mymenu__ #__menu_item__:hover {
    transition: all 250ms ease-out;
    color: var(--Colorlight)!important;
    text-shadow: 0px 0px 0px;
    font-size: 15px;
    animation: textzoom 0.4s linear 1;
    /*font-weight: bold;*/
  }
  
  @keyframes textzoom {
      0% { font-size: 0.95em; }
      50% { font-size: 1em }
      100% { font-size: 1.1em }
  }

  .fullscreenSelect {
    /*margin-left: 5px!important;*/
    left: 0.5vw !important;
    width: 99vw!important;
    background-color: rgba(255, 255, 255, 0.97)!important;
    /*opacity: 0.92;*/
    box-shadow: 0px 9px 12px 1px rgba(0,0,0,.1)!important;
  }

  .fullscreenSelect .el-scrollbar__wrap {
    height: auto;
    max-height: 80vh;
  }
  
  .__mymenu__ .el-input input {
    /*width: 99vw!important;*/
    border-radius: 0px;
    border-width: 0px !important;
  }
  


</style>














queryMenus(keyword,render) {
    keyword = keyword.toLowerCase();
    var menus = View.menus, JS = JSON.parse, guiderBar = View.guiderBar.menus, guid = guiderBar[0].parentId, results = [];
    if( !menus ) {
      menus = View.menus = {__proto__:null};
      const storage = window.localStorage, only = {__proto__:null};
      ['two','three','four','five','six','seven','eight','nine','ten']. forEach((v,index,id)=>{ 
        // console.error( storage.getItem(v+'List') );
        v = storage.getItem(v+'List');
        if( !v ) return;
        ( menus[id = (v = JS(v))[0].parentId] = v ).forEach((v2,index2,value2)=>{
          // menus[menus.length++] = v2;
          value2 = v2.actionName, v2.index = index + '|' + (++index2) + '-' + 1;
          v2.childrenId.forEach((v3,index3,value3)=>{
            v3.index=index+'|'+index2+'-'+(index3+1);
            // ( value3 = v3.value = v3.actionName ).toLowerCase().includes(keyword) && ( 
            PinyinMatch( value3 = v3.value = v3.actionName, keyword ) && ( 
              results[id!==guid?'push':'unshift'](v3),
              value3 === value2 && ( value2 = false )
            );
          });
          value2 && PinyinMatch( value2, keyword )  && results[id!==guid?'push':'unshift'](v2);
          // value2 && value2.toLowerCase().includes(keyword) && results[id!==guid?'push':'unshift'](v2);

        },index=35-id);
      });
    }else {
      forObj(menus,v=>{
        v.forEach((v2,id,value2)=>{
          id = v2.parentId, value2 = v2.value;
          v2.childrenId.forEach((v3,value3)=>{
            // v3.index=index+'|'+index2+'-'+(index3+1);
            // ( value3 = v3.value = v3.actionName ).toLowerCase().includes(keyword) && ( 
            PinyinMatch( value3 = v3.value = v3.actionName, keyword ) && ( 
              results[id!==guid?'push':'unshift'](v3),
              value3 === value2 && ( value2 = false )
            );
          });
          value2 && PinyinMatch( value2, keyword ) && results[id!==guid?'push':'unshift'](v2);
          // value2 && value2.toLowerCase().includes(keyword) && results[id!==guid?'push':'unshift'](v2);
        });
      });
    };

    render(results);

  },


// WEBPACK FOOTER //
// src/components/$MyMenu.vue